// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world


$w.onReady(function () {
    // Write your JavaScript here

    // To select an element by ID use: $w("#elementID")
    console.log($w('#text44').text)

    $w("#dynamicDataset").onReady( () => {
  		if ($w("#text44").text === "Amit Yizraeli") {
			$w('#contactPic').src = "https://media-exp1.licdn.com/dms/image/C4D03AQFERzLmsg7ThQ/profile-displayphoto-shrink_200_200/0/1609159216997?e=1615420800&v=beta&t=0UtAaGIb1Xhrg5hwEynQNiI4aOxk5NCCI5NZuoFKIoI";
			console.log("Amit is the contact guy");
		} else if ($w("#text44").text === "Mirit Sulema") {
			$w('#contactPic').src = 'wix:image://v1/040028_986057222fc741dca5a491cb861eb18c~mv2_d_7360_4912_s_4_2.jpg/Mirit%20Sulema.JPG#originWidth=7360&originHeight=4912';
			console.log("Mirit is the contact woman");
		} else if ($w('#text44').text === "Gary Levy") {
			$w('#contactPic').src = "https://static.wixstatic.com/media/040028_1a3076b548134951b76a9481a67a3f8b~mv2_d_7360_4912_s_4_2.jpg";
			console.log("Gary is the contact guy");
		}
	} );

    // Click "Preview" to run your code
});